import React, { useReducer, useContext, useEffect } from 'react';
import MainContext from '../../../../store/MainContext';
import API from '../../../../api/axios';
import StripedTable from 'components/Table/StripedTable';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import FullCard from '../../../../components/Card/FullCard';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const DistancePercent = React.memo((props) => {
  // -- Functions:

  const initialState = {
    percents: [],
    fields: {
      min: { text: '', error: null },
      max: { text: '', error: null },
      percent: { text: '', error: null },
    },
    isLoaded: false,
    select: {},
    errors: [],
  };

  function reducer(state, action) {
    const { payload, type } = action;

    switch (type) {
      case 'PERCENTS':
        return {
          ...state,
          percents: payload,
          isLoaded: true,
        };
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      case 'CHANGE_FIELDS':
        return {
          ...state,
          fields: { ...state.fields, [payload.name]: { text: payload.value } },
        };
      case 'ERROR':
        return {
          ...state,
          fields: {
            ...state.fields,
            [payload.name]: {
              ...state.fields[payload.name],
              error: payload.error,
            },
          },
          errors: [...state.errors, payload.error],
        };
      case 'CLEAR_ERRORS':
        return { ...state, errors: [] };
      default:
        return { ...state };
    }
  }
  const handleChangeFields = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    dispatch({ type: 'CHANGE_FIELDS', payload: { name, value } });
  };
  const handleDelete = (id) => {
    API(`/api/v1/admin/distancepercent/${id}`, {
      method: 'delete',
    })
      .then((res) => {
        props.showMessage(2, 'bc', 'حذف', 'رکورد مورد نظر حذف گردید.');
        loadPercents();
      })
      .catch((err) => {
        props.showMessage(3, 'bc', 'خطا', 'بروز خطای سرور');
        console.error(err);
      });
  };
  const loadPercents = async () => {
    try {
      const response = await API.get(`/api/v1/admin/distancepercent/list`);
      dispatch({ type: 'PERCENTS', payload: response.data });
    } catch (err) {
      console.error(err);
    }
  };
  const error = (fieldName, errorMsg) => {
    errors.push(errorMsg);
    dispatch({
      type: 'ERROR',
      payload: { name: fieldName, error: errorMsg },
    });
  };
  const addNewDistancePercent = async () => {
    dispatch({ type: 'CLEAR_ERRORS' });
    !state.fields.min.text && error('min', 'مقدار حداقل را وارد نمایید');
    !state.fields.max.text && error('max', 'مقدار حداکثر را وارد نمایید');
    !state.fields.percent.text && error('percent', 'درصد بایستی وارد شود.');

    if (errors.length > 0) {
      props.showMessage(
        2,
        'tr',
        'اخطار',
        errors.map((e, i) => <li key={i}>{e}</li>)
      );
    } else {
      API(`/api/v1/admin/distancepercent`, {
        method: 'post',
        data: {
          min: state.fields.min.text,
          max: state.fields.max.text,
          percent: state.fields.percent.text,
        },
      })
        .then((response) => {
          props.showMessage(
            1,
            'tr',
            'افزودن',
            'رکورد مورد نظر با موفقیت افزوده شد'
          );
          loadPercents();
        })
        .catch((err) => {
          console.error(err);
          props.showMessage(3, 'tr', 'خطا', 'بروز خطا در سرور');
        });
    }
  };

  // -- Variables:
  const adminState = useContext(MainContext);
  const itemsCountPerPage = adminState.itemsCountPerPage;
  const [state, dispatch] = useReducer(reducer, initialState);
  var errors = [];

  // Render:
  const addDistancePercentForm = state.isLoaded ? (
    <form>
      <Grid container direction="column" alignItems="stretch" spacing={1}>
        <Grid item>
          <TextField
            type="number"
            name="min"
            value={state.fields.min.text}
            onChange={handleChangeFields}
            label="از چند کلیومتر؟ عدد وارد کنید"
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item>
          <TextField
            type="number"
            name="max"
            value={state.fields.max.text}
            onChange={handleChangeFields}
            label="تا چند کلیومتر؟ عدد وارد کنید"
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item>
          <TextField
            type="number"
            name="percent"
            value={state.fields.percent.text}
            onChange={handleChangeFields}
            label="ضریب مسافت به عدد وارد شود"
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            fullWidth
            onClick={addNewDistancePercent}
          >
            ذخیره
          </Button>
        </Grid>
      </Grid>
    </form>
  ) : (
    <Skeleton width="100%" height={38} />
  );

  const distancePercentTable = state.isLoaded ? (
    <div className="distancePercent">
      <StripedTable
        thArray={['از کیلومتر', 'تا کیلومتر', 'ضریب', 'حذف']}
        tdArray={state.percents.map((p) => {
          return [
            p.min,
            p.max,
            p.percent,
            <IconButton onClick={() => handleDelete(p._id)}>
              <DeleteIcon />
            </IconButton>,
          ];
        })}
      />
    </div>
  ) : (
    <Skeleton count={itemsCountPerPage} height={30} />
  );

  const body = (
    <FullCard
      title={props.config.name}
      category="از طریق فرم ذیل می توانید مشخص کنید از x کیلومتر تا y کیلومتر چقدر ضریب برای محاسبه کرایه در نظر گرفته شود."
    >
      <div className="content">
        <Grid container direction="row" spacing={1} justify="flex-start">
          <Grid item xs={12} lg={8}>
            {distancePercentTable}
          </Grid>
          <Grid item xs={12} lg={4}>
            {addDistancePercentForm}
          </Grid>
        </Grid>
      </div>
    </FullCard>
  );

  useEffect(() => {
    loadPercents();
  }, []);
  if (state.isLoaded) {
    //console.error(JSON.stringify(state, null, 2));
  }

  return body;
});
export default DistancePercent;
